import React from 'react';
import { Box } from '@mui/material';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import { DashboardMenu } from './DashboardMenu';
import { CreatorContextMenu } from './CreatorContextMenu';
import { getRole } from './helpers';
import { PermissionScope } from '@playbook-technologies/common-enums';

export const AdminMenu = React.memo(function AdminMenu({
  isAdminContext,
  logout,
  customPermissions,
}: {
  isAdminContext: boolean;
  logout: () => void;
  customPermissions: Array<PermissionScope>;
}) {
  if (isAdminContext) {
    return (
      <DashboardMenu logout={logout} customPermissions={customPermissions} />
    );
  }
  return <CreatorPagesMenu />;
});

const CreatorPagesMenu = () => {
  const influencerId = useInfluencerId();
  const { influencer } = useInfluencer({
    creatorId: influencerId,
  });
  const role = getRole();

  return (
    <>
      {influencer ? (
        <CreatorContextMenu influencer={influencer} role={role} />
      ) : null}
    </>
  );
};
